<template>
    <div class='menu-wrapper'>
        <template v-for="item in routes">
            <router-link v-if="!item.hidden&&item.noDropdown&&item.children.length>0&&item.path!=='/dataBoard'"
                         :to="item.path+'/'+item.children[0].path">
                <el-menu-item :index="item.path+'/'+item.children[0].path" class='submenu-title-noDropdown'>
                    <icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg>
                    <span>{{ $t(item.children[0].name) }}</span>
                </el-menu-item>
            </router-link>
            <router-link v-if="!item.hidden&&item.noDropdown&&item.children.length>0&&item.path==='/dataBoard'"
                         :to="'/largeScreen'">
                <el-menu-item :index="item.path+'/'+item.children[0].path" class='submenu-title-noDropdown'>
                    <icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg>
                    <span>{{ $t(item.children[0].name) }}</span>
                </el-menu-item>
            </router-link>
            <el-submenu v-if="!item.noDropdown&&!item.hidden" :index="item.name">
                <template v-if="!item.icon.includes('el-icon')" slot="title">
                    <icon-svg v-if='item.icon' :icon-class="item.icon"></icon-svg>
                    <span>{{ $t(item.name) }}</span>
                </template>
                <template v-if="item.icon.includes('el-icon')" slot="title">
                    <i :class="item.icon" class="icon-I"></i><span>{{ $t(item.name) }}</span>
                </template>
                <template v-for="child in item.children" v-if='!child.hidden'>

                    <sidebar-item v-if='child.children&&child.children.length>0' :routes='[child]'
                                  class='nest-menu'></sidebar-item>

                    <router-link v-else :to="item.path+'/'+child.path">
                        <el-menu-item :index="item.path+'/'+child.path">
                            <icon-svg v-if='child.icon' :icon-class="child.icon"></icon-svg>
                            <span>{{ $t(child.name) }}</span>
                        </el-menu-item>
                    </router-link>

                </template>

            </el-submenu>

        </template>
    </div>
</template>

<script>
export default {
    name: 'SidebarItem',
    props: {
        routes: {
            type: Array
        }
    }
}
</script>
<style scoped>
.icon-I {
    width: 20px;
    height: 20px;
    margin-right: 12px;
}
</style>




// WEBPACK FOOTER //
// SidebarItem.vue?7ba38639